/* Info Component on the Day component */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../../styles/Callsheets.module.css";
import { useCurrentUser } from "../../../contexts/CurrentUserContext";

const InfoStrip = ({callsheet}) => {
    const currentUser = useCurrentUser();
    const projectType = currentUser?.project_category_type
    ? JSON.parse(currentUser?.project_category_type)
    : null;

    console.log(projectType)
  return (
    <div>
        <Row className='my-3'>
            <Col className={`px-3 py-2 ${styles.SubTitle6 }`} md={{span: 10, offset: 1 }}>
            <p className={`${styles.Red} text-center`}>SCHEDULE STRIPBOARD INFO</p>
            <hr className={`mt-2 mb-0`}/>
            <p className='pt-2'>
            <span className={`${styles.Red}`}>*</span> Add Scenes to the Stripboard by clicking the <span className={`${styles.Red}`}>Add Scene</span> tab.
            </p>
            {projectType !== "Television" ? (
              <>
            <p className='pt-2'>
            <span className={`${styles.Red}`}>*</span> On the Add Scene page select a Scene from the Act or Location Dropdowns 
            and complete the Shooting Info form.
            </p>
            </>
            ) : (
                <p className='pt-2'>
            <span className={`${styles.Red}`}>*</span> On the Add Scene page select a Scene from the Number or Location Dropdowns
            and complete the Shooting Info form.
            </p>            
            )}
              <p className='pt-2'><span className={`${styles.Red}`}>*</span> Use the <span className={`${styles.Red}`}> Film Location Dropdown</span> to 
                prefill the Film Location Name, Address and Parking/Directions/Notes info from the Location page. 
                </p>
              <p className='pt-2'><span className={`${styles.Red}`}>*</span> <span className={`${styles.Red}`}> Moves and Meal Breaks</span> are 
              added to whichever Scene they immediately 
                follow, in that Scene's <span className={`${styles.Red}`}>NEXT</span> field.
                </p>
              <p className={`pt-1`}>
                 <span className={`${styles.Red}`}>*</span> If a Scene is to be <span className={`${styles.Red}`}>deleted</span> move it to the 
                last Day Order position first to keep the automatic ordering correct.
                </p>
              {callsheet.results.length ? ("") : (
                <p className='pt-2'>
            <span className={`${styles.Red}`}>*</span> Click the Create Callsheet tab to Create the Shoot Days Callsheet. Find 
            Callsheet Info on the Callsheet page.
            </p>
              )}
              <p className={`pt-1`}>
              <span className={`${styles.Red}`}>*</span> Users who are assigned to work on the Schedule need to be given 
              the <span className={`${styles.Red}`}>Superadmin Permission</span>.
              </p>
              <p className={`${styles.Small} pt-3`}>
              <span className={`${styles.Red}`}>*</span> Important! Superadmins not assigned to work on the Schedule should not use the 
              Drag and Drop or delete Scenes.
              </p>
              <p className={`${styles.Small} pt-3`}>Note: All up to date Location details should be held on the Locations 
                   pages but the Schedule Scene Location details can also be updated on the Schedule Scene edit page.
                </p>
              <hr className={`mt-2 mb-0`}/>
            </Col>
        </Row>
    </div>
  )
}

export default InfoStrip